const currenciesAccepted = ['cad', 'eur', 'usd'];

function isCurrencyAccepted(currency: string) {
  return currenciesAccepted.includes(currency);
}

export { isCurrencyAccepted };
